import React, { createContext, useEffect, useState } from "react";
import {
  adminListApi,
  getAllRoles,
  assignbulkRoleApi,
  admiRoleListApi,
  commonRoleList,
} from "../../../api/Api";
import ViewIcon from "../../../assets/images/right-more.png";
import RouteConstants from "../../../constants/routeConstants.json";
import ContentData from "../../../constants/contentFile.json";
import CheckBox from "../../../components/CheckBoxComponent/CheckBox";
import { useCookies } from "react-cookie";

import { useNavigate, useLocation } from "react-router-dom";

import { useSearchParams } from "react-router-dom";



export const AdminManageContext = createContext({});
export const AdminManageContextProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const pageFromUrl = searchParams.get("page");
  const [adminList, setAdminList] = useState([]);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [pageCount, setPageCount] = useState(pageFromUrl ? Number(pageFromUrl) : 1);
  const [totalPage, setTotalPage] = useState(0);
  const [roleId, setRoleId] = useState("");
  const [status, setStatus] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [roleSelectData, setRoleSelectData] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [role, setRole] = useState("");
  const [roleCategotyValidate, setRoleCategotyValidate] = useState("");
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [checkBoxDisable, setCheckBoxDisable] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const [isRoleExpanded, setIsRoleExpanded] = useState(false);
  const [isStatusExpanded, setIsStatusExpanded] = useState(false);


  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "66f506fa5a192b6c70a82cd8";
  })[0];
  const roleIdentifier = JSON.parse(localStorage.getItem("roleIdentifier"));
  const isSuperAdmin = roleIdentifier === "superadmin";

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    setCheckBoxDisable(selectedUsers.length === 0 ? false : true);
    setAdminList(
      apiData?.map((user) => ({
        bulkData: (
          <div>
            <CheckBox
              key={user._id}
              id={user._id}
              //  label={user.name}
              check={selectedUsers.includes(user._id)}
              onChange={(e) => {
                handleUserIdSelected(user._id, e.target.checked);
              }}
              disabled={permissionAccess.edit ? false : true}
            />
          </div>
        ),
        name: user?.name,
        id: user?._id,
        email: user?.email,
        role: user?.role?.name,
        status: (
          <span
            style={{
              color:
                user?.status === "A"
                  ? "#13BC5B" // Green for Active
                  : user?.status === "I"
                  ? "#EB5757" // Red for Inactive
                  : user?.status === "D"
                  ? "#dc3545" // Red for Deleted
                  : user?.status === "N"
                  ? "#636E72" // Gray for Invited
                  : "#6c757d", // Default color (gray)
            }}
          >
            {user?.status === "A"
              ? "Active"
              : user?.status === "I"
              ? "Inactive"
              : user?.status === "D"
              ? "Deleted"
              : "Invited"}
          </span>
        ),
        lastLogin: user?.status === "N" ? "-" : formatDateTime(user?.lastLogin),
        action: (
          <div onClick={() => viewAdminDetail(user?._id)}>
            <span>
              <img className="viewClickAdmin" src={ViewIcon} alt="view" />
            </span>
          </div>
        ),
      }))
    );
  }, [apiData, selectedUsers]);

  const handleError = (error) => {
    const responseStatus = error?.response?.data?.statusCode;
    const errorMessage =
      error?.response?.data?.message || ContentData.tenantPage.wentWrong;

    setStatusValue(responseStatus);
    setErrorPopupMessage(errorMessage);
    setErrorPopup(true);

    if (responseStatus === 400) {
      setButtonText(ContentData.tenantPage.tryAgain);
    } else if (responseStatus === 401 || responseStatus === 403) {
      setButtonText(ContentData.tenantPage.login);
    } else {
      setButtonText(ContentData.tenantPage.tryAgain);
    }

    setSpinnerStatus(false);
  };

  const viewAdminDetail = (id) => {
    navigate(RouteConstants.VIEW_ADMIN, { state: { id } });
  };

  const onClickFilterButton = (roleId, statusId) => {
    setPageCount(1);
    setRoleId(roleId);
    setStatus(statusId);
    setShowDropdown(false);
  };

  const handleRoleChange = (e) => {
    setRole(e.target.value);
    roleValidation(e.target.value);
  };

  const roleValidation = (value) => {
    if (value === "") {
      setRoleCategotyValidate("Select role");
      return false;
    } else {
      setRoleCategotyValidate("");
      return true;
    }
  };

  // Function to handle individual selection
  const handleUserIdSelected = (userId, isChecked) => {
    setSelectedUsers(
      (prevSelectedUsers) =>
        isChecked
          ? [...prevSelectedUsers, userId] // Add the user ID if checked
          : prevSelectedUsers.filter((id) => id !== userId) // Remove the user ID if unchecked
    );
  };

  const roleListShown = async () => {
    try {
      setSpinnerStatus(true);
      const roleList = await commonRoleList();
      if (roleList?.data?.statusCode === 200) {
        setRoleList(roleList?.data?.data?.roleList);
      }
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    setSelectedUsers([]);
  }, [pageCount]);

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A"; // Handle null/undefined dates
    const date = new Date(dateString);

    // Format date: dd-mm-yyyy
    const formattedDate = date
      .toLocaleDateString("en-GB") // British format: dd/mm/yyyy
      .replace(/\//g, "-"); // Replace slashes with dashes

    // Format time: hh:mm am/pm
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = String(minutes).padStart(2, "0"); // Ensure two-digit minutes
    const formattedTime = `${hours % 12 || 12} : ${formattedMinutes} ${
      hours >= 12 ? "pm" : "am"
    }`;

    return `${formattedDate}, ${formattedTime}`;
  };

  const getAdminList = async (search, roleId, status, page) => {
    try {
      setSpinnerStatus(true);
      const adminListApiData = await adminListApi(search, roleId, status, page);
      if (adminListApiData?.status === 200) {
        setSpinnerStatus(false);
        // Function to format date and time
        setApiData(adminListApiData?.data?.data?.users);
      }
      setTotalPage(adminListApiData?.data?.data?.totalPages);
    } catch (error) {
      handleError(error);
    }
    setSpinnerStatus(false);
  };

  const bulkRoleAssignApi = async () => {
    const data = {
      users: selectedUsers,
      role: role,
    };
    const roleValidate = roleValidation(role);
    if (roleValidate) {
      try {
        setSpinnerStatus(true);
        const adminListApiData = await assignbulkRoleApi(data);
        if (adminListApiData?.data?.statusCode === 200) {
          setSuccessAlertShow(true);
          setSpinnerStatus(false);
          setSuccessAlertMessage(adminListApiData?.data?.message);
          setRoleSelectData(false);
        }
      } catch (error) {
        handleError(error);
      }
    }
  };


  const onPageChange = (e) => {
    setPageCount(e);
    const params = new URLSearchParams(location.search);
    params.set("page", e);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };


useEffect(() => {
  if (pageFromUrl) {
    setPageCount(Number(pageFromUrl));
  }
}, [pageFromUrl]);

  const onChangeSearch = (e) => {
    const specialCharacters = /[!@#$%^&*(),.?":{}|<>+\-_\/=;]/;
    if (specialCharacters.test(e.target.value)) {
      console.log("Special characters detected:", e.target.value);
    }

    setSearchData(e.target.value);
    setPageCount(1);
  };

  const adminToAddAdmin = () => {
    navigate(RouteConstants.ADD_ADMIN);
  };

  const adminActivityPage = () => {
    navigate(RouteConstants.ACTIVITY_ADMIN);
  };

  const handleSelect = () => {
    setShowDropdown(false);
  };

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const goToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const handleBulkSubmit = () => {
    getAdminList(searchData, roleId, status, pageCount);
    setSuccessAlertShow(false);
    setSelectedUsers([]);
    setRole("");
  };

  const handleSelectedAll = (isChecked) => {
    if (isChecked) {
      setSelectedUsers(adminList.map((user) => user.id));
    } else {
      setSelectedUsers([]);
    }
  };

  const statuses = [
    { id: "A", name: "Active" },
    { id: "I", name: "Inactive" },
    // { id: "D", name: "Deleted" },
    { id: "N", name: "Invited" }, // New User
  ];

  const header = [
    {
      title: (
        <CheckBox
          id="select-all"
          check={
            selectedUsers.length === adminList.length && adminList.length > 0
          }
          onChange={(e) => {
            handleSelectedAll(e.target.checked);
          }}
          additionStyle="allCheckBoxSelect"
          disabled={permissionAccess.edit ? false : true}
        />
      ),
      prop: "bulkData",
    },
    { title: "NAME", prop: "name" },
    { title: "EMAIL ADDRESS", prop: "email" },
    { title: "ROLE", prop: "role" },
    { title: "STATUS", prop: "status" },
    { title: "LAST LOGIN ", prop: "lastLogin" },
    { title: " ", prop: "action" },
  ];

  const providerValue = {
    getAdminList,
    adminList,
    onChangeSearch,
    searchData,
    spinnerStatus,
    onPageChange,
    pageCount,
    totalPage,
    handleRoleChange,
    setRoleId,
    setStatus,
    selectedRoleId,
    setSelectedRoleId,
    selectedStatusId,
    setSelectedStatusId,
    adminToAddAdmin,
    adminActivityPage,
    roleId,
    status,
    showDropdown,
    handleSelect,
    handleToggle,
    setRoleSelectData,
    roleSelectData,
    roleListShown,
    roleList,
    roleCategotyValidate,
    successAlertShow,
    successAlertMessage,
    statusValue,
    bulkRoleAssignApi,
    setSuccessAlertShow,
    selectedUsers,
    setSelectedUsers,
    setCheckBoxDisable,
    checkBoxDisable,
    setRole,
    onClickFilterButton,
    permissionAccess,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    isSuperAdmin,

    handleBulkSubmit,
    handleSelectedAll,
    isRoleExpanded,
    setIsRoleExpanded,
    isStatusExpanded,
    setIsStatusExpanded,
    statuses,
    header,
  };

  return (
    <AdminManageContext.Provider value={providerValue}>
      {children}
    </AdminManageContext.Provider>
  );
};
